export default __webpack_public_path__ + "static/media/pin-add.3b91c842.svg";